<div class="container-fluid tp-box" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip === 'active'">
		<div class="card">
			<div class="card-header card-header-warning card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(false, '')">
					<i class="material-icons">trending_up</i>
				</div>
				<h3 class="card-title">{{ cardTitle }}</h3>
			</div>
			<div class="card-body">
				<div class="dashboard-expanded-toolbar" *ngIf="searchForm" [formGroup]="searchForm">
					<mat-form-field appearance="outline" class="dashboard-date-field">
						<mat-label>Date From</mat-label>
						<input matInput [matDatepicker]="pickerFrom" formControlName="datefrom" (dateChange)="load()" />
						<mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
						<mat-datepicker #pickerFrom></mat-datepicker>
					</mat-form-field>
					<mat-form-field appearance="outline" class="dashboard-date-field">
						<mat-label>Date To</mat-label>
						<input matInput [matDatepicker]="pickerTo" formControlName="dateto" (dateChange)="load()" />
						<mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
						<mat-datepicker #pickerTo></mat-datepicker>
					</mat-form-field>
					<mat-form-field appearance="outline" class="dashboard-limit-field">
						<mat-label>Limit</mat-label>
						<input matInput type="number" formControlName="limit" (change)="load()" min="1" max="500" />
					</mat-form-field>
					<mat-form-field appearance="outline" class="dashboard-type-field">
						<mat-label>Vendor Type</mat-label>
						<mat-select formControlName="supptype" (selectionChange)="load()">
							<mat-option value="">All</mat-option>
							<mat-option *ngFor="let t of vendorTypes" [value]="t.typeid">{{ t.typename }}</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-slide-toggle formControlName="inc_disabled" (change)="load()" class="me-3 align-middle">Include inactive</mat-slide-toggle>
					<button mat-raised-button color="accent" (click)="load()" [disabled]="loading">
						<mat-icon>refresh</mat-icon>
						Refresh
					</button>
					<ng-container *ngIf="data.length && !loading">
						<button mat-raised-button class="btn-success me-2" (click)="exportXls()" [disabled]="sending">
							<i class="fa fa-file-excel-o"></i> XLS
						</button>
						<button mat-raised-button color="warn" (click)="exportPdf()" [disabled]="sending">
							<i class="fa fa-file-pdf-o"></i> PDF
						</button>
					</ng-container>
					<span *ngIf="loading">
						<svg class="spinner" width="35" height="35" viewBox="0 0 66 66">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30" />
						</svg>
					</span>
				</div>
				<div class="table-responsive" #print_table>
					<table class="table table-striped table-bordered table-hover table-fixed">
						<thead>
							<tr>
								<th (click)="sortBy('supplierid')">Vendor ID</th>
								<th (click)="sortBy('suppname')">Name</th>
								<th (click)="sortBy('termsname')">Terms</th>
								<th (click)="sortBy('transcount')">Transactions</th>
								<th (click)="sortBy('totalamount')">Total Amount</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let r of sortedData">
								<td>{{ r.supplierid }}</td>
								<td>{{ r.suppname }}</td>
								<td>{{ r.termsname }}</td>
								<td>{{ r.transcount | number }}</td>
								<td>{{ r.totalamount | currency }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip === 'inactive' ? '' : 'd-none'">
		<div class="card card-stats">
			<div class="card-header card-header-warning card-header-icon">
				<div class="card-icon pointer" (click)="toggleFlip(data, title)">
					<i class="material-icons">trending_up</i>
				</div>
				<p class="card-category">{{ cardTitle }}</p>
				<h3 class="card-title">
					<span *ngIf="!loading">{{ data.length }}</span>
					<span *ngIf="loading">
						<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
							<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
						</svg>
					</span>
				</h3>
			</div>
			<div class="card-footer">
				<div class="stats pointer">
					<a (click)="toggleFlip(data, title)">
						<i class="material-icons">content_copy</i> View Now
					</a>
				</div>
			</div>
		</div>
	</div>
</div>
